/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, CancelToken } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
import { makeCodedException, makeContent } from '@servicetitan/application-data/common-interfaces';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

export interface IPhonesPro {
    getAccountsData(cancelToken?: CancelToken): AxiosPromise<AccountSetupModel>;
    getCallContinuityData(cancelToken?: CancelToken): AxiosPromise<CallContinuityModel>;
    getUsers(cancelToken?: CancelToken): AxiosPromise<DialpadUserDTO[]>;
    saveCallContinuityNumber(callContinuityNumber: string, cancelToken?: CancelToken): AxiosPromise<ExecutionResult>;
    setIsCallContinuityEnabled(value: boolean, cancelToken?: CancelToken): AxiosPromise<ExecutionResult>;
    addRoom(name: string, cancelToken?: CancelToken): AxiosPromise<ExecutionResult>;
    deleteRoom(id: number, cancelToken?: CancelToken): AxiosPromise<ExecutionResult>;
    changeFaxLinesNumber(delta: number, cancelToken?: CancelToken): AxiosPromise<number>;
    saveAccounts(accounts: DialpadUserDTO[], cancelToken?: CancelToken): AxiosPromise<ExecutionResult>;
    getBlockedNumbers(cancelToken?: CancelToken): AxiosPromise<BlockedNumberModel[]>;
    addBlockedNumber(number: string, memo: string, cancelToken?: CancelToken): AxiosPromise<BlockedNumberModel>;
    editBlockedNumberMemo(number: string, memo: string, cancelToken?: CancelToken): AxiosPromise<void>;
    deleteBlockedNumber(number: string, cancelToken?: CancelToken): AxiosPromise<void>;
    getPhoneSettings(cancelToken?: CancelToken): AxiosPromise<PhoneSettingsModel>;
    getPhoneNumbers(cancelToken?: CancelToken): AxiosPromise<PhoneNumberModel[]>;
    getDialpadNumberAssignmentTargets(cancelToken?: CancelToken): AxiosPromise<DialpadNumberAssignmentTarget[]>;
    getDialpadNumberAssignment(phoneNumber: string, cancelToken?: CancelToken): AxiosPromise<DialpadNumberAssignmentTarget>;
    exportPhoneNumbers(cancelToken?: CancelToken): AxiosPromise<ExecutionResult>;
    getLastPhoneNumbersExport(cancelToken?: CancelToken): AxiosPromise<DataExportEvent>;
    phoneNumbersExportResult(resultId: string, cancelToken?: CancelToken): AxiosPromise<FileResponse>;
    getAvailablePhoneNumbers(filter: PhoneNumberSearchRequestModel, cancelToken?: CancelToken): AxiosPromise<AvailableNumberModel[]>;
    editDefaultSmsNumber(phoneNumber: string, cancelToken?: CancelToken): AxiosPromise<ExecutionResult>;
    editDefaultMmsNumber(phoneNumber: string, cancelToken?: CancelToken): AxiosPromise<ExecutionResult>;
    /**
     * @fileFormData (optional) 
     * @filename the original file name
     */
    uploadGreetingFile(fileFormData: FileParameter | undefined, filename: string, cancelToken?: CancelToken): AxiosPromise<ExecutionResultOfString>;
    saveGreeting(greeting: string, cancelToken?: CancelToken): AxiosPromise<ExecutionResult>;
    savePhoneNumber(model: PhoneNumberModel, cancelToken?: CancelToken): AxiosPromise<ExecutionResultOfPhoneNumberAddModel>;
    detachTcrCampaignFromPhone(phoneNumberE164: string, campaignId: number, cancelToken?: CancelToken): AxiosPromise<ExecutionResult>;
    getEmergencyPhonesFallbackData(cancelToken?: CancelToken): AxiosPromise<EmergencyPhonesFallbackModel>;
    toggleEmergencyPhonesFallback(isEnabled: boolean, cancelToken?: CancelToken): AxiosPromise<ExecutionResult>;
    toggleRealAnswerDetection(isEnabled: boolean, cancelToken?: CancelToken): AxiosPromise<ExecutionResult>;
    setRingDuration(value: number, cancelToken?: CancelToken): AxiosPromise<ExecutionResult>;
    setForwardingNumbers(numbers: string[], cancelToken?: CancelToken): AxiosPromise<ExecutionResult[]>;
    setVoicemailGreeting(greeting: string, cancelToken?: CancelToken): AxiosPromise<ExecutionResult>;
    getPowerDialerData(cancelToken?: CancelToken): AxiosPromise<PowerDialerModel>;
    changeIsPowerDialerEnabled(value: boolean, cancelToken?: CancelToken): AxiosPromise<ExecutionResult>;
    setPowerDialerFrequency(value: number, cancelToken?: CancelToken): AxiosPromise<ExecutionResult>;
    campaignDetails(id: number, cancelToken?: CancelToken): AxiosPromise<PowerDialerCampaignModel>;
    sortCampaigns(campaigns: ValueTupleOfListOfLongAndListOfLong, cancelToken?: CancelToken): AxiosPromise<PowerDialerCampaignModel[]>;
    changeIsCampaignActive(id: number, isActive: boolean | null, cancelToken?: CancelToken): AxiosPromise<ExecutionResultOfPowerDialerCampaignStatus>;
    getCampaignEditDetails(id: number | null, cancelToken?: CancelToken): AxiosPromise<PowerDialerCampaignEditModel>;
    savePowerDialerCampaign(model: PowerDialerCampaignModel, cancelToken?: CancelToken): AxiosPromise<ExecutionResultOfPowerDialerCampaignModel>;
    getCallRecordingData(cancelToken?: CancelToken): AxiosPromise<CallRecordingModel>;
    setInboundCallRecordingMode(mode: CallRecordingMode, cancelToken?: CancelToken): AxiosPromise<ExecutionResult>;
    setOutboundCallRecordingMode(mode: CallRecordingMode, cancelToken?: CancelToken): AxiosPromise<ExecutionResult>;
    setInboundGreeting(greeting: string, cancelToken?: CancelToken): AxiosPromise<ExecutionResult>;
    setOutboundGreeting(greeting: string, disclosureReminder: boolean, reminderText: string, cancelToken?: CancelToken): AxiosPromise<ExecutionResult>;
    setNumbersToExcludeFromRecording(numbers: string[], cancelToken?: CancelToken): AxiosPromise<ExecutionResult>;
    getGreetingToPlay(greeting: string, isInbound: boolean, cancelToken?: CancelToken): AxiosPromise<FileResponse>;
}

export const BASE_URL_TOKEN_PhonesPro = symbolToken<string>('BASE_URL_TOKEN', false);

@injectable()
export class PhonesPro implements IPhonesPro {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@inject(BASE_URL_TOKEN_PhonesPro) @optional() private readonly baseUrl = "") {
    }

    getAccountsData(cancelToken?: CancelToken): AxiosPromise<AccountSetupModel> {
        let url_ = "/app/api/PhonesPro/GetAccountsData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<AccountSetupModel>(options_));
    }

    getCallContinuityData(cancelToken?: CancelToken): AxiosPromise<CallContinuityModel> {
        let url_ = "/app/api/PhonesPro/GetCallContinuityData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<CallContinuityModel>(options_));
    }

    getUsers(cancelToken?: CancelToken): AxiosPromise<DialpadUserDTO[]> {
        let url_ = "/app/api/PhonesPro/GetUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<DialpadUserDTO[]>(options_));
    }

    saveCallContinuityNumber(callContinuityNumber: string, cancelToken?: CancelToken): AxiosPromise<ExecutionResult> {
        let url_ = "/app/api/PhonesPro/SaveCallContinuityNumber?";
        if (callContinuityNumber === undefined || callContinuityNumber === null)
            throw new Error("The parameter 'callContinuityNumber' must be defined and cannot be null.");
        else
            url_ += "callContinuityNumber=" + encodeURIComponent("" + callContinuityNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<ExecutionResult>(options_));
    }

    setIsCallContinuityEnabled(value: boolean, cancelToken?: CancelToken): AxiosPromise<ExecutionResult> {
        let url_ = "/app/api/PhonesPro/SetIsCallContinuityEnabled?";
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined and cannot be null.");
        else
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<ExecutionResult>(options_));
    }

    addRoom(name: string, cancelToken?: CancelToken): AxiosPromise<ExecutionResult> {
        let url_ = "/app/api/PhonesPro/AddRoom?";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined and cannot be null.");
        else
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<ExecutionResult>(options_));
    }

    deleteRoom(id: number, cancelToken?: CancelToken): AxiosPromise<ExecutionResult> {
        let url_ = "/app/api/PhonesPro/DeleteRoom?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<ExecutionResult>(options_));
    }

    changeFaxLinesNumber(delta: number, cancelToken?: CancelToken): AxiosPromise<number> {
        let url_ = "/app/api/PhonesPro/ChangeFaxLinesNumber?";
        if (delta === undefined || delta === null)
            throw new Error("The parameter 'delta' must be defined and cannot be null.");
        else
            url_ += "delta=" + encodeURIComponent("" + delta) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<number>(options_));
    }

    saveAccounts(accounts: DialpadUserDTO[], cancelToken?: CancelToken): AxiosPromise<ExecutionResult> {
        let url_ = "/app/api/PhonesPro/SaveAccounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = accounts;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<ExecutionResult>(options_));
    }

    getBlockedNumbers(cancelToken?: CancelToken): AxiosPromise<BlockedNumberModel[]> {
        let url_ = "/app/api/PhonesPro/GetBlockedNumbers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<BlockedNumberModel[]>(options_));
    }

    addBlockedNumber(number: string, memo: string, cancelToken?: CancelToken): AxiosPromise<BlockedNumberModel> {
        let url_ = "/app/api/PhonesPro/AddBlockedNumber?";
        if (number === undefined || number === null)
            throw new Error("The parameter 'number' must be defined and cannot be null.");
        else
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        if (memo === undefined || memo === null)
            throw new Error("The parameter 'memo' must be defined and cannot be null.");
        else
            url_ += "memo=" + encodeURIComponent("" + memo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<BlockedNumberModel>(options_));
    }

    editBlockedNumberMemo(number: string, memo: string, cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = "/app/api/PhonesPro/EditBlockedNumberMemo?";
        if (number === undefined || number === null)
            throw new Error("The parameter 'number' must be defined and cannot be null.");
        else
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        if (memo === undefined || memo === null)
            throw new Error("The parameter 'memo' must be defined and cannot be null.");
        else
            url_ += "memo=" + encodeURIComponent("" + memo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return makeCodedException(axios.request<void>(options_));
    }

    deleteBlockedNumber(number: string, cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = "/app/api/PhonesPro/DeleteBlockedNumber?";
        if (number === undefined || number === null)
            throw new Error("The parameter 'number' must be defined and cannot be null.");
        else
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return makeCodedException(axios.request<void>(options_));
    }

    getPhoneSettings(cancelToken?: CancelToken): AxiosPromise<PhoneSettingsModel> {
        let url_ = "/app/api/PhonesPro/GetPhoneSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<PhoneSettingsModel>(options_));
    }

    getPhoneNumbers(cancelToken?: CancelToken): AxiosPromise<PhoneNumberModel[]> {
        let url_ = "/app/api/PhonesPro/GetPhoneNumbers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<PhoneNumberModel[]>(options_));
    }

    getDialpadNumberAssignmentTargets(cancelToken?: CancelToken): AxiosPromise<DialpadNumberAssignmentTarget[]> {
        let url_ = "/app/api/PhonesPro/GetDialpadNumberAssignmentTargets";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<DialpadNumberAssignmentTarget[]>(options_));
    }

    getDialpadNumberAssignment(phoneNumber: string, cancelToken?: CancelToken): AxiosPromise<DialpadNumberAssignmentTarget> {
        let url_ = "/app/api/PhonesPro/GetDialpadNumberAssignment?";
        if (phoneNumber === undefined || phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' must be defined and cannot be null.");
        else
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<DialpadNumberAssignmentTarget>(options_));
    }

    exportPhoneNumbers(cancelToken?: CancelToken): AxiosPromise<ExecutionResult> {
        let url_ = "/app/api/PhonesPro/ExportPhoneNumbers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<ExecutionResult>(options_));
    }

    getLastPhoneNumbersExport(cancelToken?: CancelToken): AxiosPromise<DataExportEvent> {
        let url_ = "/app/api/PhonesPro/GetLastPhoneNumbersExport";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<DataExportEvent>(options_));
    }

    phoneNumbersExportResult(resultId: string, cancelToken?: CancelToken): AxiosPromise<FileResponse> {
        let url_ = "/app/api/PhonesPro/PhoneNumbersExportResult?";
        if (resultId === undefined || resultId === null)
            throw new Error("The parameter 'resultId' must be defined and cannot be null.");
        else
            url_ += "resultId=" + encodeURIComponent("" + resultId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            responseType: 'blob',
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<FileResponse>(options_));
    }

    getAvailablePhoneNumbers(filter: PhoneNumberSearchRequestModel, cancelToken?: CancelToken): AxiosPromise<AvailableNumberModel[]> {
        let url_ = "/app/api/PhonesPro/GetAvailablePhoneNumbers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = filter;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<AvailableNumberModel[]>(options_));
    }

    editDefaultSmsNumber(phoneNumber: string, cancelToken?: CancelToken): AxiosPromise<ExecutionResult> {
        let url_ = "/app/api/PhonesPro/EditDefaultSmsNumber?";
        if (phoneNumber === undefined || phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' must be defined and cannot be null.");
        else
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<ExecutionResult>(options_));
    }

    editDefaultMmsNumber(phoneNumber: string, cancelToken?: CancelToken): AxiosPromise<ExecutionResult> {
        let url_ = "/app/api/PhonesPro/EditDefaultMmsNumber?";
        if (phoneNumber === undefined || phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' must be defined and cannot be null.");
        else
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<ExecutionResult>(options_));
    }

    /**
     * @fileFormData (optional) 
     * @filename the original file name
     */
    uploadGreetingFile(fileFormData: FileParameter | undefined, filename: string, cancelToken?: CancelToken): AxiosPromise<ExecutionResultOfString> {
        let url_ = "/app/api/PhonesPro/UploadGreetingFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileFormData === null || fileFormData === undefined)
            throw new Error("The parameter 'fileFormData' cannot be null.");
        else
            content_.append("file", fileFormData.data, fileFormData.fileName ? fileFormData.fileName : "file");
        if (filename === null || filename === undefined)
            throw new Error("The parameter 'filename' cannot be null.");
        else
            content_.append("filename", filename.toString());

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<ExecutionResultOfString>(options_));
    }

    saveGreeting(greeting: string, cancelToken?: CancelToken): AxiosPromise<ExecutionResult> {
        let url_ = "/app/api/PhonesPro/SaveGreeting?";
        if (greeting === undefined || greeting === null)
            throw new Error("The parameter 'greeting' must be defined and cannot be null.");
        else
            url_ += "greeting=" + encodeURIComponent("" + greeting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<ExecutionResult>(options_));
    }

    savePhoneNumber(model: PhoneNumberModel, cancelToken?: CancelToken): AxiosPromise<ExecutionResultOfPhoneNumberAddModel> {
        let url_ = "/app/api/PhonesPro/SavePhoneNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = model;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<ExecutionResultOfPhoneNumberAddModel>(options_));
    }

    detachTcrCampaignFromPhone(phoneNumberE164: string, campaignId: number, cancelToken?: CancelToken): AxiosPromise<ExecutionResult> {
        let url_ = "/app/api/PhonesPro/DetachTcrCampaignFromPhone?";
        if (phoneNumberE164 === undefined || phoneNumberE164 === null)
            throw new Error("The parameter 'phoneNumberE164' must be defined and cannot be null.");
        else
            url_ += "phoneNumberE164=" + encodeURIComponent("" + phoneNumberE164) + "&";
        if (campaignId === undefined || campaignId === null)
            throw new Error("The parameter 'campaignId' must be defined and cannot be null.");
        else
            url_ += "campaignId=" + encodeURIComponent("" + campaignId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<ExecutionResult>(options_));
    }

    getEmergencyPhonesFallbackData(cancelToken?: CancelToken): AxiosPromise<EmergencyPhonesFallbackModel> {
        let url_ = "/app/api/PhonesPro/GetEmergencyPhonesFallbackData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<EmergencyPhonesFallbackModel>(options_));
    }

    toggleEmergencyPhonesFallback(isEnabled: boolean, cancelToken?: CancelToken): AxiosPromise<ExecutionResult> {
        let url_ = "/app/api/PhonesPro/ToggleEmergencyPhonesFallback?";
        if (isEnabled === undefined || isEnabled === null)
            throw new Error("The parameter 'isEnabled' must be defined and cannot be null.");
        else
            url_ += "isEnabled=" + encodeURIComponent("" + isEnabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<ExecutionResult>(options_));
    }

    toggleRealAnswerDetection(isEnabled: boolean, cancelToken?: CancelToken): AxiosPromise<ExecutionResult> {
        let url_ = "/app/api/PhonesPro/ToggleRealAnswerDetection?";
        if (isEnabled === undefined || isEnabled === null)
            throw new Error("The parameter 'isEnabled' must be defined and cannot be null.");
        else
            url_ += "isEnabled=" + encodeURIComponent("" + isEnabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<ExecutionResult>(options_));
    }

    setRingDuration(value: number, cancelToken?: CancelToken): AxiosPromise<ExecutionResult> {
        let url_ = "/app/api/PhonesPro/SetRingDuration?";
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined and cannot be null.");
        else
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<ExecutionResult>(options_));
    }

    setForwardingNumbers(numbers: string[], cancelToken?: CancelToken): AxiosPromise<ExecutionResult[]> {
        let url_ = "/app/api/PhonesPro/SetForwardingNumbers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = numbers;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<ExecutionResult[]>(options_));
    }

    setVoicemailGreeting(greeting: string, cancelToken?: CancelToken): AxiosPromise<ExecutionResult> {
        let url_ = "/app/api/PhonesPro/SetVoicemailGreeting?";
        if (greeting === undefined || greeting === null)
            throw new Error("The parameter 'greeting' must be defined and cannot be null.");
        else
            url_ += "greeting=" + encodeURIComponent("" + greeting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<ExecutionResult>(options_));
    }

    getPowerDialerData(cancelToken?: CancelToken): AxiosPromise<PowerDialerModel> {
        let url_ = "/app/api/PhonesPro/GetPowerDialerData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<PowerDialerModel>(options_));
    }

    changeIsPowerDialerEnabled(value: boolean, cancelToken?: CancelToken): AxiosPromise<ExecutionResult> {
        let url_ = "/app/api/PhonesPro/ChangeIsPowerDialerEnabled?";
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined and cannot be null.");
        else
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<ExecutionResult>(options_));
    }

    setPowerDialerFrequency(value: number, cancelToken?: CancelToken): AxiosPromise<ExecutionResult> {
        let url_ = "/app/api/PhonesPro/SetPowerDialerFrequency?";
        if (value === undefined || value === null)
            throw new Error("The parameter 'value' must be defined and cannot be null.");
        else
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<ExecutionResult>(options_));
    }

    campaignDetails(id: number, cancelToken?: CancelToken): AxiosPromise<PowerDialerCampaignModel> {
        let url_ = "/app/api/PhonesPro/CampaignDetails?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<PowerDialerCampaignModel>(options_));
    }

    sortCampaigns(campaigns: ValueTupleOfListOfLongAndListOfLong, cancelToken?: CancelToken): AxiosPromise<PowerDialerCampaignModel[]> {
        let url_ = "/app/api/PhonesPro/SortCampaigns";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = campaigns;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<PowerDialerCampaignModel[]>(options_));
    }

    changeIsCampaignActive(id: number, isActive: boolean | null, cancelToken?: CancelToken): AxiosPromise<ExecutionResultOfPowerDialerCampaignStatus> {
        let url_ = "/app/api/PhonesPro/ChangeIsCampaignActive?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isActive === undefined)
            throw new Error("The parameter 'isActive' must be defined.");
        else if (isActive !== null)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<ExecutionResultOfPowerDialerCampaignStatus>(options_));
    }

    getCampaignEditDetails(id: number | null, cancelToken?: CancelToken): AxiosPromise<PowerDialerCampaignEditModel> {
        let url_ = "/app/api/PhonesPro/GetCampaignEditDetails?";
        if (id === undefined)
            throw new Error("The parameter 'id' must be defined.");
        else if (id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<PowerDialerCampaignEditModel>(options_));
    }

    savePowerDialerCampaign(model: PowerDialerCampaignModel, cancelToken?: CancelToken): AxiosPromise<ExecutionResultOfPowerDialerCampaignModel> {
        let url_ = "/app/api/PhonesPro/SavePowerDialerCampaign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = model;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<ExecutionResultOfPowerDialerCampaignModel>(options_));
    }

    getCallRecordingData(cancelToken?: CancelToken): AxiosPromise<CallRecordingModel> {
        let url_ = "/app/api/PhonesPro/GetCallRecordingData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<CallRecordingModel>(options_));
    }

    setInboundCallRecordingMode(mode: CallRecordingMode, cancelToken?: CancelToken): AxiosPromise<ExecutionResult> {
        let url_ = "/app/api/PhonesPro/SetInboundCallRecordingMode?";
        if (mode === undefined || mode === null)
            throw new Error("The parameter 'mode' must be defined and cannot be null.");
        else
            url_ += "mode=" + encodeURIComponent("" + mode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<ExecutionResult>(options_));
    }

    setOutboundCallRecordingMode(mode: CallRecordingMode, cancelToken?: CancelToken): AxiosPromise<ExecutionResult> {
        let url_ = "/app/api/PhonesPro/SetOutboundCallRecordingMode?";
        if (mode === undefined || mode === null)
            throw new Error("The parameter 'mode' must be defined and cannot be null.");
        else
            url_ += "mode=" + encodeURIComponent("" + mode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<ExecutionResult>(options_));
    }

    setInboundGreeting(greeting: string, cancelToken?: CancelToken): AxiosPromise<ExecutionResult> {
        let url_ = "/app/api/PhonesPro/SetInboundGreeting?";
        if (greeting === undefined || greeting === null)
            throw new Error("The parameter 'greeting' must be defined and cannot be null.");
        else
            url_ += "greeting=" + encodeURIComponent("" + greeting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<ExecutionResult>(options_));
    }

    setOutboundGreeting(greeting: string, disclosureReminder: boolean, reminderText: string, cancelToken?: CancelToken): AxiosPromise<ExecutionResult> {
        let url_ = "/app/api/PhonesPro/SetOutboundGreeting?";
        if (greeting === undefined || greeting === null)
            throw new Error("The parameter 'greeting' must be defined and cannot be null.");
        else
            url_ += "greeting=" + encodeURIComponent("" + greeting) + "&";
        if (disclosureReminder === undefined || disclosureReminder === null)
            throw new Error("The parameter 'disclosureReminder' must be defined and cannot be null.");
        else
            url_ += "disclosureReminder=" + encodeURIComponent("" + disclosureReminder) + "&";
        if (reminderText === undefined || reminderText === null)
            throw new Error("The parameter 'reminderText' must be defined and cannot be null.");
        else
            url_ += "reminderText=" + encodeURIComponent("" + reminderText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<ExecutionResult>(options_));
    }

    setNumbersToExcludeFromRecording(numbers: string[], cancelToken?: CancelToken): AxiosPromise<ExecutionResult> {
        let url_ = "/app/api/PhonesPro/SetNumbersToExcludeFromRecording";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = numbers;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<ExecutionResult>(options_));
    }

    getGreetingToPlay(greeting: string, isInbound: boolean, cancelToken?: CancelToken): AxiosPromise<FileResponse> {
        let url_ = "/app/api/PhonesPro/GetGreetingToPlay?";
        if (greeting === undefined || greeting === null)
            throw new Error("The parameter 'greeting' must be defined and cannot be null.");
        else
            url_ += "greeting=" + encodeURIComponent("" + greeting) + "&";
        if (isInbound === undefined || isInbound === null)
            throw new Error("The parameter 'isInbound' must be defined and cannot be null.");
        else
            url_ += "isInbound=" + encodeURIComponent("" + isInbound) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            responseType: 'blob',
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<FileResponse>(options_));
    }
}

export interface AccountSetupModel {
    callContinuityNumber?: string | undefined;
    isCallContinuityEnabled: boolean;
    numberOfFaxLines?: number | undefined;
    loginToPhonesProUrl?: string | undefined;
    rooms?: DialpadRoomDTO[] | undefined;
    users?: DialpadUserDTO[] | undefined;
}

export interface DialpadDTO {
    /** ServiceTitan Id of the entity. */
    id: number;
}

export interface DialpadRoomDTO extends DialpadDTO {
    dialpadId: number;
    name?: string;
}

export interface DialpadUserDTO extends DialpadDTO {
    dialpadId: number;
    serviceTitanUserId: number;
    name?: string;
    role?: string;
    licenseType?: DialpadLicenseType;
    hasAdminAccess: boolean;
    isTechnician: boolean;
}

export enum DialpadLicenseType {
    Standard = 1,
    Advanced = 2,
    Technician = 3,
}

export interface CallContinuityModel {
    callContinuityNumber?: string | undefined;
    isCallContinuityEnabled: boolean;
}

export interface ExecutionResult {
    success: boolean;
    message?: string | undefined;
    result?: any | undefined;
}

export interface BlockedNumberModel {
    number?: string | undefined;
    formattedNumber?: string | undefined;
    dateAdded: Date;
    addedBy?: string | undefined;
    memo?: string | undefined;
    isMaster: boolean;
}

export interface PhoneSettingsModel {
    defaultForwardingNumber?: string | undefined;
    defaultSmsNumber?: string | undefined;
    defaultMmsNumber?: string | undefined;
    playGreetingModel?: PlayGreetingModel | undefined;
}

export interface PlayGreetingModel {
    defaultGreetings?: { [key: string]: string; } | undefined;
    selectedGreeting?: string | undefined;
    isFile: boolean;
}

export interface PhoneNumberModel {
    phoneNumber?: string | undefined;
    friendlyName?: string | undefined;
    isDirectDial: boolean;
    localUserId?: number | undefined;
    forwardTo?: string | undefined;
    useDefaultCallForwarding: boolean;
    dateAdded: Date;
    addedBy?: string | undefined;
    isTollFree: boolean;
    enableSms: boolean;
    campaignId?: number | undefined;
    alias?: string | undefined;
    defaultCallType?: CallType | undefined;
    isDniAllocated: boolean;
    isRecordingEnabled: boolean;
    assignmentTarget?: DialpadNumberAssignmentTarget | undefined;
    carrier: Carrier;
    tollFreeNumberVerificationStatus?: TollFreeNumberVerificationStatus | undefined;
    tcrUseCases?: TcrUseCase[] | undefined;
    tcrCampaignId?: number | undefined;
    tcrCampaignExternalId?: string | undefined;
}

export enum CallType {
    Abandoned = 0,
    Unbooked = 1,
    Excused = 2,
    Booked = 3,
    NotLead = 4,
}

export interface DialpadNumberAssignmentTarget {
    id: number;
    name?: string | undefined;
    type: DialpadNumberTargetType;
    state: DialpadNumberAssignmentTargetState;
}

export enum DialpadNumberTargetType {
    Unknown = "unknown",
    Department = "department",
    Office = "office",
    CallCenter = "callcenter",
    User = "user",
    Room = "room",
    StaffGroup = "staffgroup",
    CallRouter = "callrouter",
    Channel = "channel",
    CoachingGroup = "coachinggroup",
}

export enum DialpadNumberAssignmentTargetState {
    Unknown = "unknown",
    Active = "active",
    Cancelled = "cancelled",
    Suspended = "suspended",
    Pending = "pending",
    Deleted = "deleted",
}

export enum Carrier {
    Unknown = 0,
    Twilio = 1,
    Iris = 2,
    Thinq = 3,
}

export enum TollFreeNumberVerificationStatus {
    Unverified = 0,
    Pending = 1,
    Verified = 2,
    Other = 3,
}

export enum TcrUseCase {
    Unknown = 0,
    TFA = 1,
    ACCOUNT_NOTIFICATION = 2,
    AGENTS_FRANCHISES = 3,
    CARRIER_EXEMPT = 4,
    CHARITY = 5,
    CUSTOMER_CARE = 6,
    DELIVERY_NOTIFICATION = 7,
    EMERGENCY = 8,
    FRAUD_ALERT = 9,
    HIGHER_EDUCATION = 10,
    K12_EDUCATION = 11,
    LOW_VOLUME = 12,
    M2M = 13,
    MARKETING = 14,
    MIXED = 15,
    POLITICAL = 16,
    POLLING_VOTING = 17,
    PROXY = 18,
    PUBLIC_SERVICE_ANNOUNCEMENT = 19,
    SECURITY_ALERT = 20,
    SOCIAL = 21,
    SOLE_PROPRIETOR = 22,
    SWEEPSTAKE = 23,
    TRIAL = 24,
    UCAAS_HIGH = 25,
    UCAAS_LOW = 26,
}

export interface DataExportEvent {
    message?: string | undefined;
    success: boolean;
    userId: number;
    resultId?: string | undefined;
    type?: string | undefined;
    isLast: boolean;
    operationId: number;
    timestamp: Date;
}

export interface AvailableNumberModel {
    phoneNumber?: string | undefined;
    friendlyName?: string | undefined;
    state?: string | undefined;
}

export interface PhoneNumberSearchRequestModel {
    isLocal: boolean;
    areaCode?: string | undefined;
    zipCode?: string | undefined;
    contains?: string | undefined;
}

export interface ExecutionResultOfString extends ExecutionResult {
    result?: string;
}

export interface ExecutionResultOfPhoneNumberAddModel extends ExecutionResult {
    result?: PhoneNumberAddModel;
}

export interface PhoneNumberAddModel {
    numberModel?: PhoneNumberModel | undefined;
    dialpadOfficeSettingsUrl?: string | undefined;
}

export interface EmergencyPhonesFallbackModel {
    isEnabled: boolean;
    realAnswerDetection: boolean;
    numbers?: string[] | undefined;
    ringDuration: number;
    voicemailGreeting?: PlayGreetingModel | undefined;
}

export interface PowerDialerModel {
    isEnabled: boolean;
    frequency: number;
    campaigns?: PowerDialerCampaignModel[] | undefined;
}

export interface PowerDialerCampaignModel {
    id: number;
    name?: string | undefined;
    type: CampaignType;
    description?: string | undefined;
    defaultPage: PowerDialerCampaignDefaultPage;
    defaultPageName?: string | undefined;
    contacted: number;
    inQueue: number;
    status: PowerDialerCampaignStatus;
    lastModified: Date;
    audienceId: number;
    csrInstructions?: string | undefined;
    users?: PowerDialerCampaignUser[] | undefined;
}

export enum CampaignType {
    Default = 0,
    UnsoldEstimates = 1,
    ExpiringMemberships = 2,
    IdleAccount = 3,
    AgingEquipment = 4,
    Other = 5,
    RecurringService = 6,
    Newsletter = 7,
    ThankYou = 8,
    CustomerWelcome = 9,
    MissedCalls = 10,
}

export enum PowerDialerCampaignDefaultPage {
    NoPage = 0,
    JobDetails = 1,
    Invoice = 2,
    CustomerDetails = 3,
    LocationDetails = 4,
    Estimate = 5,
    Project = 6,
    PurchaseOrder = 7,
}

export enum PowerDialerCampaignStatus {
    Active = 0,
    Awaiting = 1,
    Empty = 2,
    Inactive = 3,
}

export interface PowerDialerCampaignUser {
    id: number;
    name?: string | undefined;
    role?: string | undefined;
    isAssigned: boolean;
    isOnline: boolean;
    otherCampaignsAssigned?: string[] | undefined;
}

export interface ValueTupleOfListOfLongAndListOfLong {
    item1: number[];
    item2: number[];
}

export interface ExecutionResultOfPowerDialerCampaignStatus extends ExecutionResult {
    result: PowerDialerCampaignStatus;
}

export interface PowerDialerCampaignEditModel {
    pages?: { [key: string]: string; } | undefined;
    campaign?: PowerDialerCampaignModel | undefined;
}

export interface ExecutionResultOfPowerDialerCampaignModel extends ExecutionResult {
    result?: PowerDialerCampaignModel;
}

export interface CallRecordingModel {
    inboundCallRecordingMode: CallRecordingMode;
    outboundCallRecordingMode: CallRecordingMode;
    inboundGreeting?: PlayGreetingModel | undefined;
    outboundGreeting?: PlayGreetingModel | undefined;
    isDisclosureReminderActive: boolean;
    disclosureReminderText?: string | undefined;
    phones?: PhoneNumberModel[] | undefined;
}

export enum CallRecordingMode {
    StartAutomatically = 0,
    DoNotStartAutomatically = 1,
    Disabled = 2,
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export type FileResponse = Blob;
